// extracted by mini-css-extract-plugin
module.exports = {"out-of-stock-message":"OutOfStockMessage_out-of-stock-message__1X-AJ"};